// extracted by mini-css-extract-plugin
export var container = "layout-module--container--DXHsK";
export var content = "layout-module--content--gOz5c";